import React from 'react'

import {
  AlertStrong,
  FormInfoAlert,
  GuideLink,
} from 'components/reusables/formInfoAlert'
import { DC3_CONFIGURATION_GUIDE_URL } from 'config/dc3'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../common'

export const NormativeDc3Alert: React.FC = () => {
  const t = useTranslationRankmi({
    prefix: `${prefix}.trainingType.normative.dc3Alert`,
  })

  return (
    <FormInfoAlert>
      <AlertStrong>{t('intro')}</AlertStrong>
      {t('body1')}
      <AlertStrong>{t('fields')}</AlertStrong>
      {t('body2')}
      <AlertStrong>{t('master')}</AlertStrong>
      {t('body3')}
      <GuideLink
        href={DC3_CONFIGURATION_GUIDE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('guideLink')}
      </GuideLink>
      .
    </FormInfoAlert>
  )
}
